export default __webpack_public_path__ + "static/media/logitech-mouse.778c7222.png";